import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/** Inline monospace for codes, ids, handles and job keys. */
export function Code({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <code className={cn('rounded bg-muted px-1 py-px font-mono text-[0.92em] text-foreground', className)}>
      {children}
    </code>
  )
}

/** A block of raw text kept whole: a platform's error, a rendered post body. */
export function CodeBlock({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <pre
      className={cn(
        'whitespace-pre-wrap break-words rounded-md bg-muted px-3 py-2 font-mono text-meta text-foreground',
        className,
      )}
    >
      {children}
    </pre>
  )
}
